import { render, staticRenderFns } from "./MatchOptionsPersonId.vue?vue&type=template&id=415db1e3&scoped=true&"
import script from "./MatchOptionsPersonId.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsPersonId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415db1e3",
  null
  
)

export default component.exports